import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
export default /*@__PURE__*/ _defineComponent({
    __name: 'AutofillChoiceChip',
    props: {
        applied: { type: Boolean },
        icon: {}
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        // One autofill choice under a form field: green once its value is on the form, outlined otherwise.
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_chip = _resolveComponent("v-chip");
            return (_openBlock(), _createBlock(_component_v_chip, {
                size: "small",
                label: "",
                color: props.applied ? 'success' : 'primary',
                variant: props.applied ? 'flat' : 'outlined',
                "prepend-icon": props.applied ? 'mdi-check' : props.icon,
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('click')))
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default"),
                    _createVNode(_component_v_tooltip, {
                        activator: "parent",
                        location: "top",
                        "max-width": "400"
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "tooltip"),
                            (props.applied)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Applied to the form."))
                                : _createCommentVNode("", true)
                        ]),
                        _: 3
                    })
                ]),
                _: 3
            }, 8, ["color", "variant", "prepend-icon"]));
        };
    }
});
